module.exports = __webpack_public_path__ + "img/partner-cofco.3406a6ea.png";